import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-why-an-bba-is-best-suited-for-you',
  templateUrl: './why-an-bba-is-best-suited-for-you.component.html',
  styleUrls: ['./why-an-bba-is-best-suited-for-you.component.scss']
})
export class WhyAnBBAIsBestSuitedForYouComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
